module.exports = __webpack_public_path__ + "img/nodeFrequencyThreshold.9b7fdd7c.png";